import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import { Pencil, Eye } from 'lucide-react';
import { SignupFormPreview } from 'components/molecules/signupFormPreview';
import { EditMode } from './editMode';
import { FormBuilderTab } from './formBuilderTab';

export const FormBuilderView = ({
  activeTab,
  onTabChange,
  formState,
  onUpdateHeader,
  onAddField,
  onUpdateField,
  onDeleteField,
  onReorderFields,
  onUpdateSubmitButton,
  onUpdateSuccessMessage,
  networkName,
  networkLogo,
  type,
  lastAddedFieldId,
  onClearLastAddedFieldId,
}) => (
  <Flex sx={{ flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
    <Flex
      sx={{
        justifyContent: 'flex-start',
        bg: 'white',
        borderBottom: '1px solid',
        borderColor: 'border.subtle',
        position: 'relative',
        width: '600px',
        m: '0 auto',
      }}
    >
      <Flex
        sx={{
          gap: '16px',
          pt: '40px',
        }}
      >
        <FormBuilderTab active={activeTab === 'edit'} icon={Pencil} label="Edit" onClick={() => onTabChange('edit')} />
        <FormBuilderTab
          active={activeTab === 'preview'}
          icon={Eye}
          label="Preview"
          onClick={() => onTabChange('preview')}
        />
      </Flex>
    </Flex>

    <Box sx={{ flex: 1, overflow: 'auto', bg: 'white' }}>
      {activeTab === 'edit' ? (
        <EditMode
          formState={formState}
          onUpdateHeader={onUpdateHeader}
          onAddField={onAddField}
          onUpdateField={onUpdateField}
          onDeleteField={onDeleteField}
          onReorderFields={onReorderFields}
          onUpdateSubmitButton={onUpdateSubmitButton}
          onUpdateSuccessMessage={onUpdateSuccessMessage}
          type={type}
          lastAddedFieldId={lastAddedFieldId}
          onClearLastAddedFieldId={onClearLastAddedFieldId}
        />
      ) : (
        <SignupFormPreview
          formState={formState}
          networkName={networkName}
          type={type}
          networkLogo={networkLogo}
          isPreviewOnly
        />
      )}
    </Box>
  </Flex>
);

FormBuilderView.propTypes = {
  activeTab: PropTypes.oneOf(['edit', 'preview']).isRequired,
  onTabChange: PropTypes.func.isRequired,
  formState: PropTypes.object,
  onUpdateHeader: PropTypes.func.isRequired,
  onAddField: PropTypes.func.isRequired,
  onUpdateField: PropTypes.func.isRequired,
  onDeleteField: PropTypes.func.isRequired,
  onReorderFields: PropTypes.func.isRequired,
  onUpdateSubmitButton: PropTypes.func.isRequired,
  onUpdateSuccessMessage: PropTypes.func.isRequired,
  networkName: PropTypes.string,
  networkLogo: PropTypes.string,
  type: PropTypes.oneOf(['form', 'success']),
  lastAddedFieldId: PropTypes.string,
  onClearLastAddedFieldId: PropTypes.func.isRequired,
};

FormBuilderView.defaultProps = {
  formState: null,
  networkName: '[Network Name]',
  networkLogo: null,
  type: 'form',
  lastAddedFieldId: null,
};
